export type PriorityConfig = {
  priority: string
  description: string
  color: string
  order?: number
  showDot?: boolean
}

export type AlertItem = {
  id: number
  title: string
  severity: 'קלה' | 'בינונית' | 'גבוהה' | 'גבוהה מאוד' | 'נמוכה'
  kpi: number
  /** ISO time of the last count. null: never calculated, so the card says so instead of showing kpi. */
  kpiComputedAt?: string | null
  text: string
  tags: string[]
  priority: string
  createdAt: string
  changedAt: string
  createdBy: string
  isEnabled: boolean
  isPinned: boolean
}

export type DisabledItem = {
  id: number
  title: string
  severity: 'קלה' | 'בינונית' | 'גבוהה' | 'גבוהה מאוד' | 'נמוכה'
  kpi?: number
  text?: string
  tags: string[]
  priority: string
  createdAt: string
  changedAt: string
  createdBy: string
}

export type ActionKey = 'edit' | 'duplicate' | 'delete'

export type MenuAction = {
  key: ActionKey
  label: string
  onClick: (id: string | number) => void
  danger?: boolean
  disabled?: boolean
  hidden?: boolean
}

export const DISABLED_ITEMS: DisabledItem[] = []

export const ALERTS: AlertItem[] = []

export const PRIORITIES: PriorityConfig[] = []

const onEdit = (_: string | number) => {
}
const onDuplicate = (_: string | number) => {
}
const onDelete = (_: string | number) => {
}

export const MENU_ACTIONS: MenuAction[] = [
  { key: 'edit', label: 'עריכת מלל וכותרת', onClick: onEdit },
  { key: 'duplicate', label: 'שכפול', onClick: onDuplicate },
  { key: 'delete', label: 'מחיקה', onClick: onDelete },
]

export const PRIORITY_BY_KEY: Record<string, PriorityConfig> =
  PRIORITIES.reduce(
    (acc, p) => {
      acc[p.priority] = p
      return acc
    },
    {} as Record<string, PriorityConfig>
  )
